'use client';

import clsx from 'clsx';
import LogoWithDate from 'public/logo-with-date.svg';

export const Logo = () => {
	return <LogoWithDate className={clsx('max-h-14', 'w-full')} />;
};
